import { IOrder, Roles } from '../types/types';
import { TRole } from '../store/reducers/users/types';

let apiHost = 'https://be.qa.evenflow.ai';
// apiHost = "https://be.dev.evenflow.ai";
switch (process.env.REACT_APP_ENV) {
  case 'production':
    apiHost = 'https://api.evenflow.ai';
    break;
  case 'QA':
    apiHost = 'https://be.qa.evenflow.ai';
    break;
  case 'uat':
    apiHost = 'https://be.uat.evenflow.ai';
    break;
  case 'dev':
    apiHost = 'https://be.dev.evenflow.ai';
    break;
  case 'local':
    apiHost = 'http://localhost:5000';
    break;
  case 'PreProd':
    apiHost = 'https://be.preprod.evenflow.ai';
    break;
  case 'Dev':
    apiHost = 'https://be.dev.evenflow.ai';
    break;
}

export const APIHost = apiHost;
export const APIUrl = `${APIHost}/api/v0`;
export const AsyncOperationsHubUrl = `${APIHost}/api/hubs/async-operations`;

// Live progress of async operations over the real-time hub. Turn an environment on only after
// the backend turned Realtime:Enabled on there (QA, uat, PreProd, Dev, then production).
// To roll back, turn it off here first, then on the backend.
const realtimeEnabledByEnv: Partial<
  Record<NonNullable<NodeJS.ProcessEnv['REACT_APP_ENV']>, boolean>
> = {
  local: true,
  dev: true,
  QA: true,
  uat: true,
  PreProd: true,
  Dev: true,
  production: true,
};
// Per-browser override for staff and local testing: '1' turns live progress on, '0' turns it off.
export const REALTIME_OVERRIDE_KEY = 'ef_realtime';

export const isRealtimeEnabled = (): boolean => {
  const override = localStorage.getItem(REALTIME_OVERRIDE_KEY);
  if (override === '1' || override === '0') return override === '1';
  return realtimeEnabledByEnv[process.env.REACT_APP_ENV ?? 'QA'] ?? false;
};

export const defaultRowsPerPageOptions = [10, 50, 100];
export const secondOptionRowsPerPageOptions = [10, 25, 50];
export const usersRowsPerPageOptions = [25, 50, 100];
export const defaultRowsPerPage = 10;
export const usersRowsPerPage = 25;
export const defaultOrder: IOrder = { isAscending: true };
export const superUser: TRole = Roles.EvenFlowAdmin;
